/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import BaseModal from 'src/common/components/Modal';
import { filesAPI } from 'src/api/modules/files';
import FullTable from 'src/common/components/FullTable';
import { columnsRecord } from './utils/list_data';
import { useSelector } from 'react-redux';
import notice from 'src/common/components/Notice';
import moment from 'moment';
import FileVersions from './FileVersions';

const MigratedFiles = ({ open, setOpen, idSession }) => {
	const [lastVersion, setLastVersion] = useState([]);
	const [allFiles, setAllFiles] = useState({});
	const [fileVersionsModal, setFileVersionsModal] = useState(false);
	const [idFileDetail, setIdFileDetail] = useState();
	const { user } = useSelector((state) => state.auth);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const [versionAccess, setVersionAccess] = useState(false);
	const showVersions = [
		'ADMINISTRADOR GENERAL',
		'RESPONSABLE DE ORGANO COLEGIADO',
		'RESPONSABLE DE NEGOCIO',
		'RESPONSABLE DE SEGUIMIENTO',
		'SISTEMA',
	];

	useEffect(() => {
		if (idSession) getFiles();
		setVersionAccess(showVersions.includes(systemLevelRole));
	}, []);

	const getFiles = () => {
		filesAPI
			.getFilesMigrated(idSession)
			.then((response) => {
				let newData = [];
				response.forEach((item) => {
					newData.push({
						...item,
						fecha:
							moment(item.fecha).format('l') +
							', ' +
							moment(item.fecha, ['DDMMMMY HH:mm:ss', 'MMMMDDY HH:mm:ss'])
								.add(24, 'hours')
								.format('HH:mm'),
						idFile: item.idEntidad,
					});
				});

				let uniquesNames = [...new Set(newData.map((e) => e.nombre))];
				getLastVersion(newData, uniquesNames);
			})
			.catch((e) => {
				notice('Ocurrió un error al cargar los archivos');
			});
	};

	const getLastVersion = (data, uniquesNames) => {
		setAllFiles(data);
		let ultimaVersionFiles = [];

		uniquesNames.forEach(function (u) {
			let itemsFiles = data.filter((e) => {
				return e.nombre === u;
			});

			let obtenermayor = itemsFiles.sort((a, b) => {
				return Number(b.versionArchivo) - Number(a.versionArchivo);
			});

			ultimaVersionFiles.push(obtenermayor[0]);
		});

		setLastVersion(ultimaVersionFiles);
	};

	const onDownload = (file) => {
		filesAPI
			.DownloadFilesMigrated(file.idFile, file.versionArchivo)
			.then((response) => {
				let blob = response;
				let da = document.createElement('a');
				da.href = URL.createObjectURL(blob);
				da.setAttribute('download', file.nombre);
				da.click();
				URL.revokeObjectURL(da.href);
				notice('Se descargo el archivo con éxito', 'success');
			})
			.catch(() => {
				notice('Ocurrió un problema al descargar el archivo', 'error');
			});
	};

	const onEye = (row) => {
		setFileVersionsModal(true);
		setIdFileDetail(row.nombre);
	};

	return (
		<BaseModal
			open={open}
			mainText="Archivos Migrados"
			onClose={() => setOpen(false)}
			onCancel={() => setOpen(false)}
			cancelLabel="cerrar"
			maxWidth="md"
		>
			<FullTable
				items={lastVersion}
				columns={columnsRecord(onDownload, onEye, versionAccess)}
			/>
			{fileVersionsModal === true && (
				<FileVersions
					open={fileVersionsModal}
					allFiles={allFiles}
					nameFileDetail={idFileDetail}
					onDownload={onDownload}
					setClose={() => {
						setFileVersionsModal(false);
					}}
				/>
			)}
		</BaseModal>
	);
};

export default MigratedFiles;
